import { render } from "./CanvasForum.vue?vue&type=template&id=7aa90c22&scoped=true"
import script from "./CanvasForum.vue?vue&type=script&lang=js"
export * from "./CanvasForum.vue?vue&type=script&lang=js"

import "./CanvasForum.vue?vue&type=style&index=0&id=7aa90c22&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa90c22"]])

export default __exports__